<template>
    <div class="layout_left">
      <div class="pc_title">
          <div class="nav_title">{{items.title}}</div>
          <ul>
              <li v-for="(item,index) in items.children" :key="index" @click="secondItemClick(item.routeValue)" :class="item.routeValue == selectedKey ?'check_link':''">{{item.title}}</li>
          </ul>
      </div>
      <!--移动端导航-->
      <div class="m_second_level">
        <div v-for="(item,index) in items.children" :key="index" @click="secondItemClick(item.routeValue)" :class="item.routeValue == selectedKey ?'m_check':''" >{{item.title}}</div>
        
      </div> 
    </div>
      
      
    
</template>

<script>
export default {
  name: 'RowSlider',
  components:{},
  props: {
    parentRouteKey:{
      type:String,
      default:''
    },
    selectedKey:{
      type:String,
      default:''
    },
    
  },

  data () {
    return {
      
      items:{}
      
    }
  },
  watch:{
    parentRouteKey(val){
        this.dealData();
    },
  },
  methods:{
    secondItemClick(pageName){
      debugger
      this.$router.push(pageName)
    },
    dealData(){
      debugger;
      let key = this.parentRouteKey;
      let naviJson = this.$store.state.global.navigatorInfo;
      let json = {};
      if(naviJson && naviJson.programs){
        let arrays = naviJson.programs;
        for(let index in arrays){
          if(arrays[index]['routeValue'] == key){
            json = arrays[index];
            break;
          }
        }
      }
      if(json != {}){
        this.items = json;
      }
    }
  },
  mounted(){
    this.dealData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../../assets/css/ks_foundation.less';
    @import '../../../assets/css/ks_media.less';
    @import '../../../assets/fonts/iconfont.css';
    
</style>
